import React from "react";
import { Button } from "@/components/ui/button";

const bands = [
  { key: "red",      label: "≤ -30%",      hint: "Occasione forte", bg: "bg-[#FF3B30]", tint: "bg-[#FF3B30]/12 text-[#B32620] border-[#FF3B30]/40" },
  { key: "yellow",   label: "-20%",         hint: "Ottima",          bg: "bg-[#F5B800]", tint: "bg-[#F5B800]/15 text-[#8A6400] border-[#F5B800]/50" },
  { key: "green",    label: "-10%",         hint: "Buona",           bg: "bg-[#34C759]", tint: "bg-[#34C759]/12 text-[#1F7A3A] border-[#34C759]/40" },
  { key: "cyan",     label: "-0.1/-9.9%",   hint: "Sotto media",     bg: "bg-[#5AC8FA]", tint: "bg-[#5AC8FA]/12 text-[#00A6B7] border-[#5AC8FA]/50" },
  { key: "positive", label: "≥ 0",          hint: "Sopra media",     bg: "bg-[#0A84FF]", tint: "bg-[#0A84FF]/10 text-[#0A5AB2] border-[#0A84FF]/40" },
];

const ScostFilterBar = ({ selected = [], onChange }) => {
  const toggle = (key) => {
    if (selected.includes(key)) onChange(selected.filter((k) => k !== key));
    else onChange([...selected, key]);
  };
  const clear = () => onChange([]);
  const allActive = selected.length === 0;

  return (
    <div className="ios-card p-4" data-testid="scost-filter-bar">
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500 font-semibold">Filtra per scostamento</div>
          <div className="text-[11px] text-slate-500 mt-0.5">Colora ed evidenzia le occasioni. Clic su più bande per combinarle.</div>
        </div>
        {selected.length > 0 && (
          <Button variant="ghost" size="sm" className="rounded-full text-[11px]" onClick={clear} data-testid="scost-clear">Mostra tutto</Button>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        <button
          onClick={clear}
          className={`px-3 h-9 rounded-full text-[12px] font-semibold transition-all ${
            allActive ? "bg-slate-900 text-white shadow-sm" : "bg-slate-100 text-slate-700 hover:bg-slate-200"
          }`}
          data-testid="scost-band-all"
        >
          Tutte le fasce
        </button>
        {bands.map((b) => {
          const active = selected.includes(b.key);
          return (
            <button
              key={b.key}
              onClick={() => toggle(b.key)}
              data-testid={`scost-band-${b.key}`}
              className={`px-3 h-9 rounded-full text-[12px] font-semibold transition-all flex items-center gap-2 border ${
                active ? `${b.tint} shadow-sm` : "bg-white text-slate-700 border-slate-200 hover:border-slate-300"
              }`}
            >
              <span className={`w-2.5 h-2.5 rounded-full ${b.bg}`} />
              <span>{b.label}</span>
              <span className="text-[10px] text-slate-500 hidden md:inline">· {b.hint}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ScostFilterBar;
